// extracted by css-extract-rspack-plugin
export default {"cls1":"Page-cls1_zmC","cls2":"Page-cls2_Ath Page-cls1_zmC"};